import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DataManagementService} from '../../services/data-management.service';
import {Student} from '../../model/student';
import {AppSettings} from '../../../app-settings';
import {Constants} from '../../constants';
import {AuthenticationService} from '../../services/authentication.service';
import {Subject} from 'rxjs';
import { RoundNameConstants } from 'src/app/round-name-constants';

@Component({
  selector: 'app-dream-university-report',
  templateUrl: './dream-university-report.component.html',
  styleUrls: ['./dream-university-report.component.css']
})
export class DreamUniversityReportComponent implements OnInit {

  dtTrigger: Subject<string> = new Subject();
     dtOptions: DataTables.Settings = {};
     filter_id;
     title;
     token;
     students: Student[];
     outgoingTerm;
     dreamUniversityPrefrences;
     outgoingTermId = '0';
     downloadDreamUniversityPreferenceExcel = AppSettings.DOWNLOAD_DREAM_UNIVERSITY_PREFERENCES;
     selectUndefinedOptionValue = '0';
     outgoingStudents = [];
     errorMessage;
  rounds: any;
  outgoingRoundId: any;
 
     constructor(private route: ActivatedRoute,
                 private dmService: DataManagementService,
                 private authenticationService: AuthenticationService) {
     }
 
     getDreamUniversityPreferences(): void {
         this.dmService.getOne(Constants.DREAM_UNIVERSITY_PREFERNCES, this.outgoingRoundId)
             .subscribe(
                 response => {
                     if (response.status === 'success') {
                         this.dreamUniversityPrefrences = response.data;
                         if (this.dreamUniversityPrefrences.length === 0) {
                             this.errorMessage = 'There is no data available for Dream University Preferences.';
                         } else {
                             this.dtTrigger.next();
                         }
                     } else if (response.status === 'fail') {
                         if (response.data.hasOwnProperty('message')) {
                             this.errorMessage = response.data.message;
                         } else {
                             this.errorMessage = 'Something went wrong. Please contact support team';
                         }
                     }
                 },
                 error => {
                     console.log(error);
                     this.errorMessage = 'Server Error';
                     // this.errorMessage = error;
                 });
     }
 
 
     roundChange() {
             this.getDreamUniversityPreferences();
      
     }

getAllRounds(): void {
  this.dmService.getAll(Constants.ROUND_SETTINGS)
    .subscribe(
      response => {
        if (response.status === 'success') {
          // Filter out PRACTICE_BIDDING_ROUND and assign to this.rounds
          this.rounds = response.data.filter(round => 
            round.outgoing_round_name_id !== parseInt(RoundNameConstants.PRACTICE_BIDDING_ROUND, 10) &&
            round.outgoing_round_name_id !== parseInt(RoundNameConstants.PRACTICE_CONFIRMATION_ROUND, 10) &&
            round.outgoing_round_name_id !== parseInt(RoundNameConstants.BIDDING_ROUND_ONE, 10) 
          );
          
          if (this.rounds.length > 0) {
            this.outgoingRoundId = this.rounds[0].outgoing_round_id;
            this.getDreamUniversityPreferences();
          }
        }
      },
      error => {
        console.error(error);
        this.errorMessage = 'Server Error';
      }
    );
}
 
     ngOnInit() {
         this.token = '?token=' + this.authenticationService.getToken();
         this.route
             .params
             .subscribe(params => {
                 this.filter_id = parseInt(params['id'], 10);
             });
        this.title = 'Dream University Preference Report';
         
         this.getAllRounds();
         this.dtOptions = {
             paging: true,
             retrieve: true,
             destroy: true,
             lengthChange: true,
             info: false
         };
     }
 
}
